// extracted by mini-css-extract-plugin
module.exports = {"confirm":"ConfirmButton_confirm__2mtMM","progress":"ConfirmButton_progress__2ce29","disabledProgress":"ConfirmButton_disabledProgress__2gr9e"};